var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"post-entertainment"},[_c('div',{class:[
      'section-title',
      _vm.darkClass && 'title' in _vm.darkClass ? _vm.darkClass.title : '',
    ]},[_c('h3',{staticClass:"title"},[_vm._v("Entertainment News")])]),_c('div',{staticClass:"row"},[_vm._l((_vm.entertainmentNewsDatas.slice(0, 4)),function(data,index){return [_c('div',{key:index,staticClass:"col-lg-6 col-md-6"},[_c('divide-card',{class:[_vm.darkClass && 'item' in _vm.darkClass ? _vm.darkClass.item : ''],attrs:{"stype":"col","datas":data}})],1)]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }